import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {AssessmentModel} from "../../../../interfaces/AssessmentModel";
import {Observable, Subject, takeUntil} from "rxjs";
import {map} from "rxjs/operators";
import {CounselingService} from "../../counseling.service";
import {MatDialog} from "@angular/material/dialog";
import {ViewAssessmentComponent} from "../view-assessment/view-assessment.component";
import {AddIndividualSessionComponent} from "../add-individual-session/add-individual-session.component";
import {AddGroupSessionComponent} from "../add-group-session/add-group-session.component";
import {EditAssessmentCounselingComponent} from "../edit-assessment-counseling/edit-assessment-counseling.component";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import firebase from "firebase/compat/app";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {FormControl} from "@angular/forms";
import {MatSelectChange} from "@angular/material/select";
import {MatSort} from "@angular/material/sort";
import {CentreService} from "../../../../services/centre.service";
import {Centre} from "../../../../interfaces/Centres";
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";
import {LogService} from "../../../../services/log.service";
import {EmployeeService} from "../../../../services/employee.service";
import Timestamp = firebase.firestore.Timestamp;
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
@Component({
    selector: 'app-assessement-table',
    templateUrl: './counseling-table.component.html',
    styleUrls: ['./counseling-table.component.scss']
})
export class CounselingTableComponent implements OnInit, OnDestroy {
    counsellors$: Observable<any[]>
    submittedBy: string | undefined | null = null

    private _destroyed$ = new Subject()
    dataSource!: MatTableDataSource<AssessmentModel>;

    centreControl = new FormControl('')
    selectedCentre = ''
    start:Date|undefined
    end:Date|undefined
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
  permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  counselling=this.permissions.filter((x)=>x.functionName=='Counselling')
  assessmentData: AssessmentModel[] = []
    currentDate = new Date().getTime()

    upcomingSessions: AssessmentModel[] = []
    displayedColumns: string[] = ['sr.no','childName', 'centreName', 'parentsName', 'conducted_by', 'dateOfAssessment', 'Action'];
    _centres$: Observable<Centre[]>;
    allpermission = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
    Counselling = this.allpermission.filter((x) => x.functionName == 'Counselling')[0]
    constructor(private readonly mFirestore: AngularFirestore,
                private readonly counselingService: CounselingService,
                private readonly matDialog: MatDialog,
                private centreService: CentreService,
                private readonly mLogService: LogService,
                private readonly mEmployeeService: EmployeeService

    ) {
        this._centres$ = this.centreService.getAllCentres().pipe(
            map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
        )
        this.counsellors$ = this.mEmployeeService.getCounsellers()

    }

    ngOnInit(): void {
        // console.log('sfsdf', this.counselingService.getCounsellingList())
        // this.counselingService.getAssessMentsList().pipe(takeUntil(this._destroyed$)).subscribe((res) => {
        //   this.assessmentData = res

        this.dataSource = new MatTableDataSource(this.assessmentData);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;


        // })
    }
    onCentreSelect($event: MatSelectChange) {
        // this.selectedCentre = $event.value
        // this.counselingService.updateCentreName($event.value);
        console.log($event.value)
        // this.counselingService.getAssessMentsListSorted(this.selectedCentre).pipe(takeUntil(this._destroyed$)).subscribe(tables => {
        //     console.log(tables)
        //     this.assessmentData = tables
        //     // this.assessmentData.reverse()
        //     this.dataSource = new MatTableDataSource(this.assessmentData);
        //     console.log(this.dataSource.data)
        //     this.dataSource.paginator = this.paginator;
        //     this.dataSource.sort = this.sort;
        // })
        // this.start   =undefined
        // this.end =undefined
    }

    ngOnDestroy(): void {
        // @ts-ignore
        this._destroyed$.next()
        this._destroyed$.complete()
    }
  clearAll(): void {
    this.centreControl.reset();
    this.selectedCentre = '';
    this.start = undefined;
    this.end = undefined;
    this.assessmentData = [];
    this.dataSource.data = [];
    this.submittedBy = null;
  }
    viewAssessment(element: AssessmentModel) {
        console.log(element)
        this.matDialog.open(ViewAssessmentComponent, {
            maxHeight: '800px',
            autoFocus: false,
            data: element
        })
      let activity={
        date:new Date().getTime(),
        section: 'Assessment Counseling',
        action: 'View',

        description: `Session Viewed in Counseling by` ,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)

    }


  downloadExcel() {
    const tableData = this.dataSource?.filteredData?.length
      ? this.dataSource.filteredData
      : this.dataSource?.data;

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Child Name</th>
        <th>Centre</th>
        <th>Parents Name</th>
        <th>Assessment Type</th>
        <th>Conducted By</th>
        <th>Assessment Date</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
      <tr>
        <td>${index + 1}</td>
        <td>${x.childName ?? '-'}</td>
        <td>${x.centreName ?? '-'}</td>
        <td>${x.parentsName ?? '-'}</td>
        <td>${x.type ?? '-'}</td>
        <td>${x.personConductingTest ?? '-'}</td>
        <td>${
        x.dateOfAssessment && x.dateOfAssessment.toDate
          ? new Date(x.dateOfAssessment.toDate()).toLocaleDateString('en-GB')
          : '-'
      }</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['\ufeff' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Assessment_List_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }




  openIndividualSessionDialog() {
        this.matDialog.open(AddIndividualSessionComponent, {
            height: '90%',
            disableClose:true,
        })
    }

    openGroupSessionDialog() {
        this.matDialog.open(AddGroupSessionComponent)

    }

    viewEdit(element: any) {
        this.matDialog.open(EditAssessmentCounselingComponent, {
            maxHeight: '800px',
            autoFocus: false,
            disableClose:true,
            data: element
        })
    }

    @needConfirmation()
    delete(element: any) {
        this.counselingService.deleteAssessment(element)
      let activity={
        date:new Date().getTime(),
        section: 'Assessment Counseling',
        action: 'Delete',

        description: `Assessment Session Deleted to Counseling by user` ,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)
    }

    private getUpcomingDate(toDate: Date | undefined) {
        const currentDate = new Date();
        // Add two months to the current date
        const futureDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, currentDate.getDate());
// Output the future date
        console.log(futureDate);
        const timestamp = firebase.firestore.Timestamp.fromDate(currentDate);
        return timestamp
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {this.dataSource.paginator.firstPage();}
    }
    search(){
        this.selectedCentre =this.centreControl.value!!
        this.counselingService.updateCentreName(this.selectedCentre);
        this.counselingService.getAssessMentsListSorted(this.selectedCentre).pipe(takeUntil(this._destroyed$)).subscribe(tables => {
            console.log(tables)
            this.assessmentData = tables



            // this.assessmentData.reverse()
if(this.start!=null && this.end !=null){
  this.assessmentData =  this.assessmentData.filter((x)=>x.dateOfAssessment!!.toDate()>=this.start!! && x.dateOfAssessment!!.toDate() <=this.end!!)
}
            this.dataSource = new MatTableDataSource(this.assessmentData);
            this.applyfilters()

            console.log(this.dataSource.data)
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        })

    }

    applyfilters() {
        this.dataSource.data=this.assessmentData
        if (this.dataSource.data.length >= 1) {
            if (this.submittedBy!=null) {
                // alert('filttering')
                this.dataSource.data = this.assessmentData.filter((x:any )=> x.personConductingTest == this.submittedBy)
            }


        }
    }
    editAccess(element: any): boolean {
        const ONE_DAY_IN_MILLISECONDS = 86400000;
        const TWO_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 2;
        const THREE_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 3;
        const FOUR_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 4;
        // console.log('into editAccess')
        // const currentTimestamp = firebase.firestore.Timestamp.fromDate(this.currentDate);
        const userData = JSON.parse(localStorage.getItem('userData')!)
        const username = userData?.userName
        // alert(currentDate.getTime() - element.createdAt)
        const currentTimestamp = Timestamp.now();
        const sessionTimestamp =element.createdAt
        // console.log('element.createdAt',element.createdAt)
        // const sessionTimestamp = firebase.firestore.Timestamp.fromDate((element.createdAt  as Timestamp).toDate()).toMillis()
        const timeDifference = currentTimestamp.toMillis() - sessionTimestamp;
      console.log('currentTimeStamp',currentTimestamp)
      console.log('sessionTimestamp',sessionTimestamp)
      console.log('isGreater',timeDifference <= TWO_DAYS_IN_MILLISECONDS)
        return (username === element.personConductingTest && timeDifference <= TWO_DAYS_IN_MILLISECONDS) ||username=='Krisha Shah'
        // return username=='Krisha Shah'
        // console.log(element.createdAt,this.currentDate )
        // console.log(this.currentDate - element.createdAt ,this.currentDate - element.createdAt <= 86400000)
        // console.log('CreatedAt',)
        // return (username == element.personConductingTest && ((this.currentDate - element.createdAt) <= TWO_DAYS_IN_MILLISECONDS))
    }
  deleteAccess(element: any): boolean {
    const ONE_DAY_IN_MILLISECONDS = 86400000;
    const TWO_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 2;
    const THREE_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 3;
    const FOUR_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 4;
    // console.log('into editAccess')
    // const currentTimestamp = firebase.firestore.Timestamp.fromDate(this.currentDate);
    const userData = JSON.parse(localStorage.getItem('userData')!)
    const username = userData?.userName
    // alert(currentDate.getTime() - element.createdAt)
    const currentTimestamp = Timestamp.now();
    const sessionTimestamp =element.createdAt
    // console.log('element.createdAt',element.createdAt)
    // const sessionTimestamp = firebase.firestore.Timestamp.fromDate((element.createdAt  as Timestamp).toDate()).toMillis()
    const timeDifference = currentTimestamp.toMillis() - sessionTimestamp;
    console.log('currentTimeStamp',currentTimestamp)
    console.log('sessionTimestamp',sessionTimestamp)
    console.log('isGreater',timeDifference <= TWO_DAYS_IN_MILLISECONDS)
    // return (username === element.personConductingTest && timeDifference <= FOUR_DAYS_IN_MILLISECONDS) ||username=='Krisha Shah'
    return username=='Krisha Shah'
    // return username=='Krisha Shah'
    // console.log(element.createdAt,this.currentDate )
    // console.log(this.currentDate - element.createdAt ,this.currentDate - element.createdAt <= 86400000)
    // console.log('CreatedAt',)
    // return (username == element.personConductingTest && ((this.currentDate - element.createdAt) <= TWO_DAYS_IN_MILLISECONDS))
  }

  protected readonly PermissionType = PermissionType;
}
